import { render } from "./AddEditCriteriaModal.vue?vue&type=template&id=99c5c3ac&scoped=true"
import script from "./AddEditCriteriaModal.vue?vue&type=script&lang=js"
export * from "./AddEditCriteriaModal.vue?vue&type=script&lang=js"

import "./AddEditCriteriaModal.vue?vue&type=style&index=0&id=99c5c3ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c5c3ac"]])

export default __exports__